/** Release versions as the backend and the release bot write them:
 *  ``MAJOR.MINOR.PATCH``, no ``v`` prefix. Compared as numbers, so
 *  1.99.0 < 1.100.0 (the backend's ``parse_semver`` does the same). */

const SEMVER_RE = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/;

export type Semver = readonly [number, number, number];

/** ``"1.100.0"`` → ``[1, 100, 0]``; anything else → ``null``. */
export function parseSemver(value: string | null | undefined): Semver | null {
  const m = SEMVER_RE.exec(value ?? "");
  return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
}

/** Negative, zero or positive, like a sort comparator. A value that
 *  isn't a version sorts below every version. */
export function compareSemver(a: string | null | undefined, b: string | null | undefined): number {
  const x = parseSemver(a);
  const y = parseSemver(b);
  if (!x || !y) return (x ? 1 : 0) - (y ? 1 : 0);
  for (let i = 0; i < 3; i += 1) {
    const d = x[i]! - y[i]!;
    if (d !== 0) return d;
  }
  return 0;
}
